<template>
  <div class="user-right-page">
    <el-card>
      <div class="header">
        <el-button type="primary" @click="openAddDialog">新增单位租户</el-button>
        <el-input v-model="searchName" placeholder="搜索单位名称" style="width: 200px; margin-left: 16px;" @keyup.enter.native="fetchList" />
      </div>
      <el-table :data="tableData" style="width: 100%; margin-top: 16px;">
        <el-table-column prop="tenantName" label="单位名称" />
        <el-table-column prop="tenantLevel" label="单位级别">
          <template slot-scope="scope">
            {{ getDictLabel('tenant_level', scope.row.tenantLevel) }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantStatus" label="租户状态">
          <template slot-scope="scope">
            {{ getDictLabel('tenant_status', scope.row.tenantStatus) }}
          </template>
        </el-table-column>
        <el-table-column prop="userCount" label="使用人数" />
        <el-table-column prop="createTime" label="创建时间" />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 16px; text-align: right;"
        background
        layout="prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="pageNum"
        @current-change="fetchList"
      />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="单位名称" prop="tenantName">
          <el-input v-model="form.tenantName" />
        </el-form-item>
        <el-form-item label="单位级别" prop="tenantLevel">
          <el-select v-model="form.tenantLevel" placeholder="请选择">
            <el-option v-for="(item, index) in dicts.tenant_level" :key="`tenant-level-${item.dictValue}-${index}`" :label="item.dictLabel" :value="parseInt(item.dictValue)" />
          </el-select>
        </el-form-item>
        <el-form-item label="租户状态" prop="tenantStatus">
          <el-select v-model="form.tenantStatus" placeholder="请选择">
            <el-option v-for="(item, index) in dicts.tenant_status" :key="`tenant-status-${item.dictValue}-${index}`" :label="item.dictLabel" :value="parseInt(item.dictValue)" />
          </el-select>
        </el-form-item>
        <el-form-item label="单位简介" prop="tenantDescription">
          <el-input v-model="form.tenantDescription" type="textarea" />
        </el-form-item>
        <el-form-item label="费用周期(年)" prop="feeCycleYears">
          <el-input-number v-model="form.feeCycleYears" :min="1" />
        </el-form-item>
        <el-form-item label="服务开通时间" prop="serviceStartTime">
          <el-date-picker v-model="form.serviceStartTime" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="视频文件" prop="videoUrl">
          <div class="video-upload-container">
            <el-upload
              ref="videoUpload"
              :file-list="videoFileList"
              :limit="1"
              accept="video/*"
              :auto-upload="false"
              action=""
              :on-change="handleVideoChange"
              :on-remove="handleVideoRemove"
              :on-exceed="handleVideoExceed"
            >
              <el-button size="small" type="primary" :loading="uploading">
                <i class="el-icon-upload"></i> 选择视频文件
              </el-button>
              <div slot="tip" class="el-upload__tip">
                支持mp4/avi/mov格式，且不超过100MB
              </div>
            </el-upload>
            <div v-if="form.videoUrl" class="video-preview">
              <video 
                :src="form.videoUrl" 
                controls 
                preload="metadata"
                style="width: 300px; height: 200px; margin-top: 10px; background: #000;"
                @error="handleVideoError"
                @loadstart="handleVideoLoadStart"
                @loadedmetadata="handleVideoLoaded"
              >
                您的浏览器不支持视频播放
              </video>
              <div v-if="videoLoadError" class="video-error">
                <el-alert
                  title="视频加载失败"
                  :description="videoLoadError"
                  type="error"
                  :closable="false"
                  show-icon
                />
                <el-button size="mini" type="primary" @click="refreshVideoUrl" style="margin-top: 10px;">
                  重新加载视频
                </el-button>
              </div>
              <div v-if="!videoLoadError" class="video-actions">
                <el-button size="mini" type="text" @click="previewVideo">预览</el-button>
                <el-button size="mini" type="text" @click="downloadVideo">下载</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getDictData } from '@/api/dict'
import { getTenantList, addTenant, updateTenant, deleteTenant, getTenantById } from '@/api/tenant'

export default {
  name: 'UserRight',
  data() {
    return {
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchName: '',
      dialogVisible: false,
      dialogTitle: '',
      form: {
        tenantId: '',
        tenantName: '',
        tenantLevel: '',
        tenantStatus: '',
        tenantDescription: '',
        feeCycleYears: 1,
        serviceStartTime: '',
        videoUrl: ''
      },
      rules: {
        tenantName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
        tenantLevel: [{ required: true, message: '请选择单位级别', trigger: 'change' }],
        tenantStatus: [{ required: true, message: '请选择租户状态', trigger: 'change' }]
      },
      dicts: {
        tenant_level: [],
        tenant_status: []
      },
      // 视频上传相关
      videoFileList: [],
      uploading: false,
      selectedVideoFile: null,
      videoLoadError: null
    }
  },
  created() {
    this.fetchDicts()
    this.fetchList()
  },
  methods: {
    /** 共用库 dict_data 可能重复插入，按 dictValue 去重 */
    dedupeDictByValue(list) {
      const seen = new Set()
      return (list || []).filter((item) => {
        const key = String(item.dictValue)
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    async fetchDicts() {
      try {
        const [levelRes, statusRes] = await Promise.all([
          getDictData('tenant_level'),
          getDictData('tenant_status')
        ])
        this.dicts.tenant_level = this.dedupeDictByValue(levelRes.data || [])
        this.dicts.tenant_status = this.dedupeDictByValue(statusRes.data || [])
      } catch (error) {
        console.error('加载字典数据失败:', error)
      }
    },
    async fetchList() {
      try {
        const res = await getTenantList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          tenantName: this.searchName
        })
        this.tableData = res.data.records || []
        this.total = res.data.total || 0
      } catch (error) {
        console.error('获取租户列表失败:', error)
      }
    },
    getDictLabel(type, value) {
      const item = this.dicts[type].find(i => parseInt(i.dictValue) === value)
      return item ? item.dictLabel : value
    },
    openAddDialog() {
      this.dialogTitle = '新增单位租户'
      this.dialogVisible = true
      this.form = {
        tenantId: '',
        tenantName: '',
        tenantLevel: '',
        tenantStatus: '',
        tenantDescription: '',
        feeCycleYears: 1,
        serviceStartTime: '',
        videoUrl: ''
      }
      this.videoFileList = []
      this.selectedVideoFile = null
    },
    async openEditDialog(row) {
      this.dialogTitle = '编辑单位租户'
      this.dialogVisible = true
      this.videoLoadError = null
      
      try {
        // 重新获取租户详情，确保获取到最新的下载链接（30分钟有效期）
        const res = await getTenantById(row.tenantId)
        
        // 使用最新获取的数据
        this.form = { ...res.data }
        
        // 如果有视频URL，设置文件列表用于显示
        if (this.form.videoUrl) {
          this.videoFileList = [{
            name: '庭审视频',
            url: this.form.videoUrl,
            status: 'success'
          }]
          console.log('编辑租户，获取到的最新videoUrl:', this.form.videoUrl)
        } else {
          this.videoFileList = []
          console.log('编辑租户，未获取到videoUrl')
        }
      } catch (error) {
        console.error('获取租户详情失败，使用列表数据:', error)
        // 如果获取详情失败，使用列表中的数据
        this.form = { ...row }
        if (row.videoUrl) {
          this.videoFileList = [{
            name: '庭审视频',
            url: row.videoUrl,
            status: 'success'
          }]
        } else {
          this.videoFileList = []
        }
      }
      
      this.selectedVideoFile = null
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()
        const isEdit = !!this.form.tenantId
        
        this.uploading = true

        // 如果选择了视频文件：先保存/更新租户基本信息（不带文件），再直传OSS，最后绑定videoPath（彻底分离）
        if (this.selectedVideoFile) {
          let tenantId = this.form.tenantId

          // 0) 确保 tenantId：新增先创建并拿到真实 tenantId（不上传视频）
          if (!tenantId) {
            const createForm = new FormData()
            createForm.append('tenantName', this.form.tenantName)
            createForm.append('tenantLevel', this.form.tenantLevel)
            createForm.append('tenantStatus', this.form.tenantStatus)
            createForm.append('tenantDescription', this.form.tenantDescription || '')
            createForm.append('feeCycleYears', this.form.feeCycleYears)
            createForm.append('serviceStartTime', this.form.serviceStartTime || '')

            const createRes = await request({
              url: '/api/tenant/create',
              method: 'post',
              data: createForm,
              headers: { 'Content-Type': 'multipart/form-data' }
            })
            tenantId = createRes.data
            this.form.tenantId = tenantId
          } else {
            // 编辑：先更新基本信息（不带文件）
            const baseForm = new FormData()
            baseForm.append('tenantId', tenantId)
            baseForm.append('tenantName', this.form.tenantName)
            baseForm.append('tenantLevel', this.form.tenantLevel)
            baseForm.append('tenantStatus', this.form.tenantStatus)
            baseForm.append('tenantDescription', this.form.tenantDescription || '')
            baseForm.append('feeCycleYears', this.form.feeCycleYears)
            baseForm.append('serviceStartTime', this.form.serviceStartTime || '')

            await request({
              url: '/api/tenant/update',
              method: 'put',
              data: baseForm,
              headers: { 'Content-Type': 'multipart/form-data' }
            })
          }

          // 1) 获取预签名 PUT URL + videoPath
          const fileName = this.selectedVideoFile.name || ''
          const fileExt = (fileName.includes('.') ? fileName.split('.').pop() : 'mp4') || 'mp4'
          const contentType = this.selectedVideoFile.type || 'application/octet-stream'

          const presignRes = await request({
            url: '/api/tenant/video/presign',
            method: 'get',
            showLoading: false,
            params: { tenantId, ext: fileExt, contentType }
          })

          const { uploadUrl, videoPath, previewUrl } = presignRes.data || {}
          if (!uploadUrl || !videoPath) {
            throw new Error('获取上传地址失败')
          }

          // 2) 直传 OSS（绕过后端/网关）
          const putRes = await fetch(uploadUrl, {
            method: 'PUT',
            headers: { 'Content-Type': contentType },
            body: this.selectedVideoFile
          })
          if (!putRes.ok) {
            throw new Error('视频直传失败，请重试')
          }

          // 3) 绑定 videoPath（小请求体，不触发413）
          const response = await request.put(`/api/tenant/${tenantId}/video`, { videoPath })

          // 立即更新本地预览（后端仍会在查询时转换为临时下载链接）
          if (previewUrl) {
            this.form.videoUrl = previewUrl
          }

          console.log('绑定租户视频响应:', response)
        } else {
          // 没有选择视频文件：保持旧链路不动（请求体很小，不会触发413）
          const formData = new FormData()
          formData.append('tenantName', this.form.tenantName)
          formData.append('tenantLevel', this.form.tenantLevel)
          formData.append('tenantStatus', this.form.tenantStatus)
          formData.append('tenantDescription', this.form.tenantDescription || '')
          formData.append('feeCycleYears', this.form.feeCycleYears)
          formData.append('serviceStartTime', this.form.serviceStartTime || '')
          if (isEdit) {
            formData.append('tenantId', this.form.tenantId)
          }

          const response = await request({
            url: isEdit ? '/api/tenant/update' : '/api/tenant/add',
            method: isEdit ? 'put' : 'post',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          console.log('保存租户响应:', response)
        }
        
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.fetchList()
        this.uploading = false
      } catch (error) {
        this.uploading = false
        if (error === false) return // 表单验证失败
        console.error('保存租户失败:', error)
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该单位租户吗？', '提示', { type: 'warning' })
        await deleteTenant(row.tenantId)
        this.$message.success('删除成功')
        this.fetchList()
      } catch (error) {
        if (error === 'cancel') return
        console.error('删除租户失败:', error)
      }
    },
    // 视频超出数量限制时触发（选择新视频时自动替换旧视频）
    handleVideoExceed(files, fileList) {
      console.log('=== 超出文件数量限制，自动替换旧视频 ===')
      // 清空旧文件
      this.$refs.videoUpload.clearFiles()
      this.videoFileList = []
      this.selectedVideoFile = null
      this.form.videoUrl = ''
      this.videoLoadError = null
      
      // 手动添加新文件
      const file = files[0]
      this.$refs.videoUpload.handleStart(file)
      
      // 触发 handleVideoChange
      this.handleVideoChange({ raw: file, name: file.name }, [{ raw: file, name: file.name }])
    },
    // 视频上传相关方法
    handleVideoChange(file, fileList) {
      console.log('=== handleVideoChange 开始 ===')
      console.log('file对象:', file)
      console.log('file.name:', file.name)
      console.log('file.raw:', file.raw)
      console.log('fileList:', fileList)
      
      // 检查 file.raw 是否存在
      if (!file.raw) {
        console.error('file.raw 不存在，可能是文件已经在列表中')
        return
      }
      
      // 验证文件类型
      console.log('file.raw.type:', file.raw.type)
      const isVideo = file.raw.type.startsWith('video/')
      if (!isVideo) {
        console.error('文件类型验证失败:', file.raw.type)
        this.$message.error('只能上传视频文件!')
        this.$refs.videoUpload.clearFiles()
        return
      }
      console.log('文件类型验证通过')
      
      // 验证文件大小 (100MB)
      const fileSizeMB = file.raw.size / 1024 / 1024
      console.log('文件大小 (MB):', fileSizeMB)
      const isLt100M = fileSizeMB < 100
      if (!isLt100M) {
        console.error('文件大小超过限制:', fileSizeMB, 'MB')
        this.$message.error('视频文件大小不能超过 100MB!')
        this.$refs.videoUpload.clearFiles()
        return
      }
      console.log('文件大小验证通过')
      
      // 清空旧的视频URL（重新选择视频时）
      this.form.videoUrl = ''
      this.videoLoadError = null
      
      // 更新文件列表，只保留新选择的文件
      this.videoFileList = fileList
      
      // 保存选择的文件
      this.selectedVideoFile = file.raw
      console.log('✅ 选择视频文件成功:', file.name)
      console.log('✅ selectedVideoFile 已设置:', this.selectedVideoFile)
      console.log('=== handleVideoChange 结束 ===')
    },
    handleVideoRemove(file, fileList) {
      this.form.videoUrl = ''
      this.selectedVideoFile = null
      this.$message.info('已移除视频文件')
    },
    previewVideo() {
      if (this.form.videoUrl) {
        window.open(this.form.videoUrl, '_blank')
      }
    },
    downloadVideo() {
      if (this.form.videoUrl) {
        const link = document.createElement('a')
        link.href = this.form.videoUrl
        link.download = '庭审视频'
        link.target = '_blank'
        link.click()
      }
    },
    // 视频加载错误处理
    handleVideoError(event) {
      console.error('视频加载失败:', event)
      const video = event.target
      if (video.error) {
        switch (video.error.code) {
          case video.error.MEDIA_ERR_ABORTED:
            this.videoLoadError = '视频加载被中止'
            break
          case video.error.MEDIA_ERR_NETWORK:
            this.videoLoadError = '网络错误导致视频加载失败，请检查网络连接'
            break
          case video.error.MEDIA_ERR_DECODE:
            this.videoLoadError = '视频解码失败，可能视频文件已损坏'
            break
          case video.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
            this.videoLoadError = '视频格式不支持或视频源不可用'
            break
          default:
            this.videoLoadError = '视频加载失败，请稍后重试'
        }
      } else {
        this.videoLoadError = '视频加载失败，请稍后重试'
      }
    },
    // 视频开始加载
    handleVideoLoadStart() {
      this.videoLoadError = null
      console.log('视频开始加载:', this.form.videoUrl)
    },
    // 视频元数据加载完成
    handleVideoLoaded(event) {
      console.log('视频元数据加载完成')
      this.videoLoadError = null
    },
    // 重新加载视频URL
    async refreshVideoUrl() {
      if (!this.form.tenantId) {
        this.$message.warning('请先保存租户信息')
        return
      }
      
      try {
        this.videoLoadError = null
        // 重新获取租户详情，获取最新的视频URL
        const res = await getTenantById(this.form.tenantId)
        if (res.data && res.data.videoUrl) {
          this.form.videoUrl = res.data.videoUrl
          this.videoFileList = [{
            name: '庭审视频',
            url: res.data.videoUrl,
            status: 'success'
          }]
          this.$message.success('视频URL已刷新，请稍候视频将自动加载')
        } else {
          this.$message.warning('未找到视频文件')
        }
      } catch (error) {
        console.error('刷新视频URL失败:', error)
        this.$message.error('刷新视频URL失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.user-right-page {
  padding: 24px;
}
.header {
  display: flex;
  align-items: center;
}
.video-upload-container {
  width: 100%;
}
.video-preview {
  margin-top: 10px;
}
.video-actions {
  margin-top: 8px;
}
.video-actions .el-button {
  margin-right: 8px;
}
.video-error {
  margin-top: 10px;
}
.video-preview video {
  display: block;
  max-width: 100%;
}
</style> 